import React from 'react';
import { Box, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Info } from '../Info/Info';
import { CustomNumber } from '../Number/Number';
import { priceFormat } from '../../../../components/tableCellRenders';
import { HEADER_VALUE_GAP, headerValueStyle } from '../headerStyles';

interface Props {
  title: string;
  value?: number | null;
  tooltip?: React.ReactNode;
}

const formatRoundedPrice = (value?: number | null) =>
  priceFormat({
    value: value ? Math.round(value) : value,
    hideEmptyCents: true,
  });

export const PortfolioMoneyStat: React.FC<Props> = ({
  title,
  value,
  tooltip,
}) => (
  <Info title={title}>
    <Box display="flex" alignItems="center" pt={HEADER_VALUE_GAP}>
      <CustomNumber
        value={value ?? undefined}
        typographyStyle={{
          ...headerValueStyle,
          paddingTop: '0px',
          paddingBottom: '0px',
        }}
      >
        {formatRoundedPrice(value)}
      </CustomNumber>
      {tooltip && (
        <Tooltip title={tooltip} placement="top">
          <InfoOutlinedIcon
            color="secondary"
            sx={{ fontSize: '1.25rem', marginLeft: '0.4rem' }}
          />
        </Tooltip>
      )}
    </Box>
  </Info>
);
